import { t } from "ttag";

import { useSendCheckoutLink } from "@/features/onboarding/hooks/use-send-checkout-link";
import type { OnboardingUser } from "@/features/onboarding/models";
import { Button, Heading, Input, LetterIcon } from "@/shared/ui";

export const SendCheckoutLinkCard = ({
  code,
  email,
}: Pick<OnboardingUser, "code" | "email">) => {
  const sendCheckoutLink = useSendCheckoutLink();

  return (
    <div className="flex flex-col gap-2.5 rounded-2xl border border-neutral-300 p-5">
      <div>
        <Heading level={3} size="small" weight="medium">
          {t`Patient side`}
        </Heading>

        <p className="text-sm text-neutral-700">{t`The patient will receive an email to complete their order.`}</p>
      </div>

      <div className="mf-masked mf-listen">
        <Input.Root readOnly value={email}>
          <Input.Slot>
            <LetterIcon />
          </Input.Slot>
        </Input.Root>
      </div>

      <Button
        size="lg"
        disabled={sendCheckoutLink.isPending}
        onClick={() => sendCheckoutLink.mutate(code)}
      >
        {t`Send Checkout Link`}
      </Button>
    </div>
  );
};
